import CardBusiness from "~/components/bookingScreen/CardBusiness";
import CardReservations from "~/components/bookingScreen/CardReservations";
import Footer from "~/components/common/footerContainer/FooterContainer";
import SpinnerLoading from "~/components/common/spinnerLoading/SpinnerLoading";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import businessAction from "~/store/actions/businessAction";
import {
	sendTokenFirebase,
} from "~/services/loginService";
import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { useParams } from "react-router-dom";

const BookingScreen = (props) => {
	const { bookingTransactionId, token } = useParams();
	const { id } = useParams();
	const { i18n, t } = useTranslation();
	const { business } = useSelector((store) => store.business);
	const { user } = useSelector((store) => store.auth);
	const [businessesList, setBusinessesList] = useState([]);
	
	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const language = storageLanguage ?? business?.language;

	useEffect(() => {
		document.body.style.backgroundColor = "#F6F6F3";
		return () => { document.body.style.backgroundColor = ""; };
	}, []);

	useEffect(() => {
		if (business) {
			if (language === "portuguese" || language === "portugal") {
				i18n.changeLanguage("pt-BR");
			} else if (language === "spanish") {
				i18n.changeLanguage("es-ES");
			} else {
				i18n.changeLanguage("en-US");
			}
		}
	}, [business, i18n]);
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (business) {
			if (token) {
				return sendTokenFirebase(token).then((res) => {
					props.history.replace(`/business/${business?.id}`, {
						goBackRoute: `/business/${business?.id}`,
						goBackRouteProps: props.location.state,
					});
				});
			}
			if (user && (user.isAnonymous || !user.uid)) {
				localStorage.setItem("goBackRoute", JSON.stringify("/business/" + business.id + "/bookingTransactionId/" + bookingTransactionId));
				props.history.push(`/business/link/${business.id}`, {
					goBackRoute: "/business/" + business.id + "/bookingTransactionId/" + bookingTransactionId,
					goBackRouteProps: props.location.state,
				});
			}
		} else {
			//dispatch(businessAction.getBusiness(id));	
		}
		setLoading(false);
	}, [business]);

	useEffect(() => {
		// Salva o goBackRoute apenas se não houver um no state (preservado pelo PrivateRoute)
		if (!props.location.state?.goBackRoute) {
			localStorage.setItem("goBackRoute", JSON.stringify(window.location.pathname));
		} else {
			localStorage.setItem("goBackRoute", JSON.stringify(props.location.state.goBackRoute));
		}
	}, []);

	return (
		<TitleContainer footer={<Footer section="reservas" businessesList={businessesList}/>} childrenStyle={{ padding: 0, backgroundColor: "#F6F6F3" }}>
			<SpinnerLoading loading={loading} />
			<CardReservations user={user} setBusinessesList={setBusinessesList}/>
		</TitleContainer>
	);
};
export default withRouter(BookingScreen);
